export const CATEGORY_CHANGED = 'CATEGORY_CHANGED'

export const categoryChanged = () => {
  return dispatch => {
    dispatch({ type: CATEGORY_CHANGED })
  }
}
